import { render, staticRenderFns } from "./WhatsNewList.vue?vue&type=template&id=73a70c2e&scoped=true"
import script from "./WhatsNewList.vue?vue&type=script&lang=js"
export * from "./WhatsNewList.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewList.vue?vue&type=style&index=0&id=73a70c2e&prod&lang=scss&scoped=true"
import style1 from "./WhatsNewList.vue?vue&type=style&index=1&id=73a70c2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a70c2e",
  null
  
)

export default component.exports